import React from 'react';
import { Send } from 'lucide-react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import Button from '../../common/Button';

interface SubmitButtonProps {
  loading: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ loading }) => {
  const { t } = useTranslatedContent('contact');

  return (
    <div className="flex justify-end">
      <Button 
        type="submit"
        variant="primary" 
        icon={Send}
        className="w-full md:w-auto bg-gradient-to-r from-blue-500 to-violet-500 hover:from-blue-600 hover:to-violet-600 border-0"
        disabled={loading}
      >
        {loading ? t('form.sending') : t('form.submit')}
      </Button>
    </div>
  );
};

export default SubmitButton;